<div
  class="carousel"
  [ngStyle]="{
    'width.px': carouselOptions.width,
    'height.px': carouselOptions.height
  }"
>
  <div
    [ngStyle]="{ 'left.px': leftPositionPx }"
    class="carousel-items"
    fxLayout="row"
    fxLayoutGap="{{ carouselOptions.gap }}px"
  >
    <ng-content></ng-content>
  </div>
</div>
